/* Template: Component - Page Selector
========================================================================== */
template.component.pageSelector = function() {

  var $selector = $('.page-selector'),
      $label = $('.page-selector__label'),
      label = '.page-selector__label',
      $dropdown = $('.page-selector__dropdown'),
      activeClass = 'page-selector--active';

    $(document).click(function(event) {
        if(!$(event.target).closest('.page-selector').length) {
            if($('.page-selector').is(":visible")) {
                $dropdown.hide();
                $selector.removeClass(activeClass);
            }
        }
    });

    $label.click(function() {
        $dropdown.toggle();
        $selector.toggleClass(activeClass);

        if ($(this).attr('aria-expanded', 'false')) {
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).attr('aria-expanded', 'false');
        }
    });

    $(document).keydown(function(objEvent) {
        if (objEvent.keyCode === 13 || objEvent.keyCode === 32) {

            $(label + ':focus').click();
        }
    });
};
